import React, { useMemo } from 'react';
import { TagRecord } from '../../api/fetchAptConfig';
import { AntTooltip } from '../common/AntTooltip';

export type AptTagsPanelProps = {
    allAppointmentTags: TagRecord[];
    selectedTags: Set<number>;
    onTagClick: (aid: string, tagId: number) => void;
    aid: string;
    taggedTagIds: number[];
    onAddNewClick: () => void;
};

function AptTagsPanel({
    allAppointmentTags,
    selectedTags,
    onTagClick,
    aid,
    taggedTagIds,
    onAddNewClick,
}: AptTagsPanelProps): JSX.Element {
    const taggedTagIdsSet = new Set(taggedTagIds);

    const appointmentTags = useMemo(
        () =>
            [...allAppointmentTags]
                .filter((tag) => tag.archive === false)
                .sort((l, r) => {
                    let score = 0;
                    if (selectedTags.has(l.tag_id) && selectedTags.has(r.tag_id)) {
                        score += 0;
                    } else if (selectedTags.has(l.tag_id)) {
                        score -= 100;
                    } else if (selectedTags.has(r.tag_id)) {
                        score += 100;
                    }

                    if (taggedTagIdsSet.has(l.tag_id) && taggedTagIdsSet.has(r.tag_id)) {
                        score += 0;
                    } else if (taggedTagIdsSet.has(l.tag_id)) {
                        score -= 10;
                    } else if (taggedTagIdsSet.has(r.tag_id)) {
                        score += 10;
                    }

                    score += l.label.localeCompare(r.label);

                    return score;
                }),
        [allAppointmentTags.length],
    );
    console.log('%c Line:25 🍷 appointmentTags', 'color:#ea7e5c', appointmentTags);

    if (appointmentTags.length === 0) {
        return <></>;
    }

    return (
        <div className="flex flex-col min-w-208 max-w-208 max-h-304">
            <div className="flex justify-between items-center px-16 py-12">
                <p className="text-13 font-700">Select Tags</p>
                <AntTooltip placement="right" content={'Create a Tag'}>
                    <div
                        onClick={onAddNewClick}
                        className="min-w-20 min-h-20 max-h-20 max-w-20 rounded-full bg-darwin-primary-200 text-darwin-primary-500 flex justify-center items-center cursor-pointer"
                    >
                        <svg
                            className="w-16 h-16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18.5 12C18.5 12.5625 18.0312 13.0312 17.5 13.0312H13V17.5312C13 18.0625 12.5312 18.5 12 18.5C11.4375 18.5 11 18.0625 11 17.5312V13.0312H6.5C5.9375 13.0312 5.5 12.5625 5.5 12C5.5 11.4688 5.9375 11.0312 6.5 11.0312H11V6.53125C11 5.96875 11.4375 5.5 12 5.5C12.5312 5.5 13 5.96875 13 6.53125V11.0312H17.5C18.0312 11 18.5 11.4688 18.5 12Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                </AntTooltip>
            </div>

            <div className="flex flex-col font-700 text-11 overflow-auto">
                {appointmentTags.map((val, idx) => {
                    const isSelected = taggedTagIdsSet.has(val.tag_id);
                    const { label, hex: textColor, bg_hex: backgroundColor, tag_id } = val;

                    return (
                        <div
                            className={`flex px-16 py-8 ${
                                appointmentTags.length - 1 !== idx
                                    ? 'border-b border-neutral-9'
                                    : ''
                            }`}
                        >
                            <div
                                key={`${tag_id}-${isSelected}`}
                                onClick={() => {
                                    // track('TAG_AN_APPOINTMENT', { previouslySelected: `${isSelected}` });
                                    onTagClick(aid, tag_id);
                                }}
                                style={
                                    isSelected
                                        ? {
                                              color: textColor,
                                              backgroundColor,
                                          }
                                        : {}
                                }
                                className={`px-8 py-4 rounded-8 border border-darwin-neutral-100 whitespace-nowrap min-w-max text-darwin-neutral-900 cursor-pointer mr-8`}
                            >
                                {label}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default AptTagsPanel;
